import {
  DependencyList,
  useContext,
  useEffect,
} from 'react';
import isNil from 'lodash/isNil';
import {
  SignalRHubContext,
} from 'core/context/signalRHub';

export const hubEvents = [
  'OnEncounterAdded',
  'OnEncounterUpdated',
  'OnEncounterDeleted',
  'OnUnreadToDoCountUpdated',
  'OnUserMessageStateUpdated',
  'OnToDoUpdated',
  'OnToDoCommentAdded',
  'OnTerminalPaymentUpdated',
  'OnReportCompleted',
  'OnFinalizedVisitNotePdfReady',
  'OnVisitNoteUpdated',
  'OnBulkPatientStatementCompleted',
  'OnStickyUpdated',
  'OnInvoiceUpdated',
  'OnBulkPaperClaimsCompleted',
  'OnSnapProgress',
  'OnEOBExtractionProgress',
  'OnPatientAlertUpdated',
  'OnRoomStatusUpdated',
  'OnPCCEligibilityUpdated',
  'OnPCCCommuniqueUpdated',
] as const;

type HubEvent = typeof hubEvents[number];

export default function useSignalREffect(
  eventName: HubEvent,
  callback: (...args: any[]) => void,
  dependencies: DependencyList = [],
) {
  const { hubConnection } = useContext(SignalRHubContext);

  useEffect(() => {
    if (!isNil(hubConnection)) {
      hubConnection?.on?.(eventName, callback);
    }
    return () => {
      hubConnection?.off?.(eventName, callback);
    };
  }, [hubConnection, ...dependencies]);
}
